import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchHistoricalVehiclesSalesDetail = (queryString) => {
  const startDate = queryString.startDate ? `&startDate=${queryString.startDate}` : '';
  const endDate = queryString.endDate ? `&endDate=${queryString.endDate}` : '';
  const dealerRuc = queryString.dealer ? `&dealer_ruc=${queryString.dealer}` : '';
  const model = queryString.model ? `&model=${queryString.model}` : '';

  return apiActionCreator({
    'endpoint': `/vehicles/historicalSales/detail?${startDate}${endDate}${dealerRuc}${model}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_HISTORICAL_VEHICLES_SALES_DETAIL,
      ActionTypes.FETCHED_HISTORICAL_VEHICLES_SALES_DETAIL,
      [
        ActionTypes.FETCHED_HISTORICAL_VEHICLES_SALES_DETAIL_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const downloadHistoricalVehiclesSalesDetail = (queryString) => {
  const startDate = queryString.startDate ? `&startDate=${queryString.startDate}` : '';
  const endDate = queryString.endDate ? `&endDate=${queryString.endDate}` : '';
  const dealerRuc = queryString.dealer ? `&dealer_ruc=${queryString.dealer}` : '';
  const model = queryString.model ? `&model=${queryString.model}` : '';

  return apiActionCreator({
    'endpoint': `/vehicles/historicalSales/detail/excel?${startDate}${endDate}${dealerRuc}${model}`,
    'authenticated': true,
    'types': [
      ActionTypes.DOWNLOADING_HISTORICAL_VEHICLES_SALES_DETAIL,
      ActionTypes.DOWNLOADED_HISTORICAL_VEHICLES_SALES_DETAIL,
      [
        ActionTypes.DOWNLOADED_HISTORICAL_VEHICLES_SALES_DETAIL_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const clearHistoricalVehiclesSalesDetail = () => ({
  'type': ActionTypes.CLEAR_HISTORICAL_VEHICLES_SALES_DETAIL,
});

export const changeSalesDetailListPage = (value) => ({
  'type': ActionTypes.CHANGE_SALES_DETAIL_LIST_PAGE,
  'payload': value,
});

export const changeSalesDetailListPageSize = (value) => ({
  'type': ActionTypes.CHANGE_SALES_DETAIL_LIST_PAGE_SIZE,
  'payload': value,
});

export const clearUrlFileForSalesDetail = () => ({
  'type': ActionTypes.CLEAR_URL_FILE_FOR_SALES_DETAIL,
});
